// Initialize theme object
window.theme = window.theme || {};

import '../scripts/legacy/theme.dev.js';
/* import '../scripts/components/'; */
import '../scripts/utils/helpers';
import '../scripts/components/product-recommendations.js';
import '../scripts/components/mobile-slider-thumbs.js';

// Development-only logging

console.log('main.bundle.js loaded');

// Dispatch event when theme bundle is loaded
document.dispatchEvent(new CustomEvent('theme:loaded'));
window.theme.loaded = true;
